module.exports = __webpack_public_path__ + "media/images/static/top/urban/center-0269e5065ff37952b1a278284f5ecfc0.png";